import $ from 'jquery';

$(function () {

	function scrollFunctions() {
		updateHeaderBg();
	}

	const $header = $('.header');
	function updateHeaderBg() {
		if ($(window).scrollTop() >= 50) {
			$header.addClass('header-bg');
		} else {
			$header.removeClass('header-bg');
		}
	}
	$(window).on('scroll', scrollFunctions);
	scrollFunctions();

	const slider = {};
	$('.slick-slider').each(function (index) {
		let id = $(this).attr('id');
		if (!id) {
			id = 'slick-' + index;
			$(this).attr('id', id);
		}

		const $slider = $(this);
		const dataArrows = $slider.data('arrows');
		const dataAutoplay = $slider.data('autoplay');
		const autoplayStartMin = Number($slider.data('autoplayStartMin'));
		const autoplayStartMax = Number($slider.data('autoplayStartMax'));
		const autoplaySpeedMin = Number($slider.data('autoplaySpeedMin'));
		const autoplaySpeedMax = Number($slider.data('autoplaySpeedMax'));

		const useArrows = dataArrows === undefined ? true : Boolean(dataArrows);
		const useAutoplay = dataAutoplay === undefined ? true : Boolean(dataAutoplay);

		const hasStartRange = Number.isFinite(autoplayStartMin) && Number.isFinite(autoplayStartMax);
		const hasSpeedRange = Number.isFinite(autoplaySpeedMin) && Number.isFinite(autoplaySpeedMax);

		const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
		const startDelay = hasStartRange ? randomInt(autoplayStartMin, autoplayStartMax) : 0;
		const autoplaySpeed = hasSpeedRange ? randomInt(autoplaySpeedMin, autoplaySpeedMax) : 5000;

		const slickOptions = {
			dots: false,
			arrows: useArrows,
			infinite: true,
			adaptiveHeight: true,
			autoplay: false,
			autoplaySpeed: autoplaySpeed
		};

		if (useArrows) {
			slickOptions.prevArrow = '<button class="slick-prev custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none"><path d="M35 14L21 28L35 42" stroke="white" stroke-width="4"/></svg></button>';
			slickOptions.nextArrow = '<button class="slick-next custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">  <path d="M21 42L35 28L21 14" stroke="white" stroke-width="4"/></svg></button>';
		}

		slider[id] = $slider.slick(slickOptions);

		if (useAutoplay) {
			setTimeout(() => {
				$slider.slick('slickSetOption', 'autoplaySpeed', autoplaySpeed, true);
				$slider.slick('slickPlay');
			}, Math.max(0, startDelay));
		}
	});



	$('.with-svg').each(function () {
		const $icon = $(this);
		const hoverColor = $icon.data('icon-hover-color');

		// Eredeti fill értékek eltárolása
		$icon.find('svg path').each(function () {
			const originalFill = $(this).attr('fill') || '';
			$(this).data('original-fill', originalFill);
		});

		// Hover IN
		$icon.on('mouseenter', function () {
			$(this).find('svg path').attr('fill', hoverColor);
		});

		// Hover OUT
		$icon.on('mouseleave', function () {
			$(this).find('svg path').each(function () {
				$(this).attr('fill', $(this).data('original-fill'));
			});
		});
	});

	// Lazy-load deferred media (video/img) using IntersectionObserver.
	// Falls back to immediate load if IntersectionObserver is not available.
	function loadDeferredElement($el) {
		var src = $el.data('deferred-src');
		if (!src) return;
		$el.attr('src', src);
		$el.removeAttr('data-deferred-src');
		if ($el.is('video')) {
			$el[0].load();
			$el[0].play().catch(function () { });
		}
	}

	var deferredEls = $('[data-deferred-src]');
	if (deferredEls.length > 0) {
		if ('IntersectionObserver' in window) {
			var observer = new IntersectionObserver(function (entries, obs) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						loadDeferredElement($(entry.target));
						obs.unobserve(entry.target);
					}
				});
			}, { rootMargin: '200px' });

			deferredEls.each(function () {
				observer.observe(this);
			});
		} else {
			// Fallback for browsers without IntersectionObserver
			deferredEls.each(function () {
				loadDeferredElement($(this));
			});
		}
	}

	$(document).on('click', '[data-href]', function (e) {
		e.preventDefault();
		const href = $(this).data('href');
		if (!href) return;

		if ($(this).data('target') === '_blank') {
			window.open(href, '_blank');
		} else {
			window.location.href = href;
		}
	});

	if ($('.email-protected').length > 0) {
		document.querySelectorAll('a.email-protected').forEach(function (el) {
			var email = el.dataset.u + '@' + el.dataset.d;
			el.textContent = email;
			el.href = 'mailto:' + email;
		});
	}

	$('[data-href]').css('cursor', 'pointer');

	function normalizeSearchInput(value) {
		if (!value) return '';
		return value
			.toString()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase()
			.replace(/[^a-z0-9\s]+/g, ' ')
			.replace(/\s+/g, ' ')
			.trim();
	}

	const $globalSearch = $('#headerGlobalSearch');
	const $globalSearchInput = $('#headerGlobalSearchInput');
	const $globalSearchResults = $('#headerGlobalSearchResults');
	let globalSearchTimer = null;
	let globalSearchRequest = null;

	function renderGlobalSearchResults(items) {
		if (!items || !items.length) {
			$globalSearchResults.html('<div class="header-global-search-empty">Nincs találat</div>');
			return;
		}

		const html = items.map(function (item) {
			const imageHtml = item.image
				? '<img src="' + item.image + '" alt="' + (item.name || '') + '">'
				: '<span class="header-global-search-thumb-placeholder"></span>';

			return '' +
				'<a href="' + item.url + '" class="header-global-search-item">' +
				'<span class="header-global-search-thumb">' + imageHtml + '</span>' +
				'<span class="header-global-search-text">' +
				'<span class="header-global-search-name">' + (item.name || '') + '</span>' +
				(item.subtitle ? '<span class="header-global-search-subtitle">' + item.subtitle + '</span>' : '') +
				'</span>' +
				'</a>';
		}).join('');

		$globalSearchResults.html(html);
	}

	function runGlobalSearch() {
		if (!$globalSearch.length) return;

		const rawQuery = $globalSearchInput.val() || '';
		const normalized = normalizeSearchInput(rawQuery);

		if (normalized.length < 2) {
			$globalSearchResults.empty();
			return;
		}

		if (globalSearchRequest) {
			globalSearchRequest.abort();
		}

		globalSearchRequest = $.ajax({
			url: '/products/global-search',
			method: 'GET',
			dataType: 'json',
			data: { q: normalized },
			success: function (response) {
				renderGlobalSearchResults(response.items || []);
			},
			error: function (xhr) {
				if (xhr.statusText === 'abort') return;
				$globalSearchResults.empty();
			}
		});
	}

	function openGlobalSearch() {
		if (!$globalSearch.length) return;
		$globalSearch.addClass('is-open').attr('aria-hidden', 'false');
		$('body').addClass('header-search-open');
		setTimeout(function () {
			$globalSearchInput.trigger('focus');
		}, 20);
	}

	function closeGlobalSearch() {
		if (!$globalSearch.length) return;
		$globalSearch.removeClass('is-open').attr('aria-hidden', 'true');
		$('body').removeClass('header-search-open');
		$globalSearchInput.val('');
		$globalSearchResults.empty();
	}

	$(document).on('click', '.js-header-search-toggle', function (e) {
		e.preventDefault();
		if ($globalSearch.hasClass('is-open')) {
			closeGlobalSearch();
		} else {
			openGlobalSearch();
		}
	});

	$(document).on('click', '#headerGlobalSearchClose', function () {
		closeGlobalSearch();
	});

	$(document).on('input', '#headerGlobalSearchInput', function () {
		clearTimeout(globalSearchTimer);
		globalSearchTimer = setTimeout(runGlobalSearch, 250);
	});

	$(document).on('keydown', '#headerGlobalSearchInput', function (e) {
		if (e.key !== 'Enter') return;
		e.preventDefault();

		const normalized = normalizeSearchInput($globalSearchInput.val() || '');
		if (!normalized) {
			closeGlobalSearch();
			return;
		}

		window.location.href = '/products?search=' + encodeURIComponent(normalized);
	});

	$(document).on('keydown', function (e) {
		if (e.key === 'Escape' && $globalSearch.hasClass('is-open')) {
			closeGlobalSearch();
		}
	});

	$(document).on('click', function (e) {
		if (!$globalSearch.hasClass('is-open')) return;
		if ($(e.target).closest('#headerGlobalSearch, .js-header-search-toggle').length) return;
		closeGlobalSearch();
	});

});


